// extracted by mini-css-extract-plugin
module.exports = {"compulsoryFrameTitleWrapper":"compulsoryFrameLabel__compulsoryFrameTitleWrapper___kmGK0","compulsoryFrameTitle":"compulsoryFrameLabel__compulsoryFrameTitle___UZqXO"};